/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 */

;(window as any).__Zone_disable_customElements = true
